export default __webpack_public_path__ + "static/media/close.15dd7bf0.svg";